// src/user/pages/UserWorkflowThankYouPage.js
import React, { useContext, useEffect } from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import { UserProfileContext } from '../contexts/UserProfileContext';
import { handleSmartBack } from '../../shared/utils/navigationUtils';

/**
 * Shown after an anonymous visitor completes a User Workflow (feedback /
 * public flow). Keeps them off the root "my accesses" page so they are not
 * prompted to enroll as a field engineer.
 */
export default function UserWorkflowThankYouPage() {
  const { access_key } = useParams();
  const { setTopBarProps } = useOutletContext();
  const { markUserWorkflowAccess } = useContext(UserProfileContext);

  useEffect(() => {
    setTopBarProps({
      headerText: 'Thank you',
      onLeftIconClick: handleSmartBack,
      rightIconClass: '',
      onRightIconClick: () => {},
    });
  }, [setTopBarProps]);

  useEffect(() => {
    if (access_key) {
      markUserWorkflowAccess(access_key);
    }
  }, [access_key, markUserWorkflowAccess]);

  return (
    <div className="container py-4 px-3">
      <div className="card border-0 shadow-sm mx-auto" style={{ maxWidth: '28rem' }}>
        <div className="card-body p-4 text-center">
          <div className="text-success mb-3" aria-hidden="true">
            <i className="bi bi-check-circle-fill fs-1" />
          </div>
          <h1 className="h4 fw-semibold mb-2">Thank you</h1>
          <p className="text-muted mb-0">
            Your submission has been received. You can close this window or tab
            when you are done.
          </p>
        </div>
      </div>
    </div>
  );
}
